"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timeline = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const CONTAINER_STYLE = {
  marginTop: 40
};
class Timeline extends react_1.default.Component {
  render() {
    const timeline = this.props.timeline;
    return react_1.default.createElement("div", {
      style: CONTAINER_STYLE
    }, react_1.default.createElement(antd_1.Timeline, null, timeline.map(_ref => {
      let key = _ref.key,
        title = _ref.title,
        dot = _ref.dot,
        style = _ref.style,
        color = _ref.color,
        titleStyle = _ref.titleStyle,
        comment = _ref.comment,
        commentStyle = _ref.commentStyle;
      return react_1.default.createElement(antd_1.Timeline.Item, {
        key: key,
        dot: dot,
        color: color,
        style: style
      }, react_1.default.createElement("p", {
        style: titleStyle
      }, title), react_1.default.createElement("p", {
        style: commentStyle
      }, comment));
    })));
  }
}
exports.Timeline = Timeline;
exports.default = Timeline;